import { getFieldByKey } from "../components/MainContent/hooks/useTableColumnsConfig";

// Configuration for different locales
export const LOCALE_CONFIG = {
  'de-DE': {
    locale: 'de-DE',
    name: 'German',
    decimalSeparator: ',',
    thousandsSeparator: '.'
  },
  'en-US': {
    locale: 'en-US', 
    name: 'English (US)',
    decimalSeparator: '.',
    thousandsSeparator: ','
  },
  'de-DE-custom': {
    locale: 'en-US', // Use en-US formatting but for German users who prefer points
    name: 'German (with points)',
    decimalSeparator: '.',
    thousandsSeparator: ','
  }
};

// Custom formatting with dots for both thousands and decimals
function customFormatNumber(value, options = {}) {
  if (value === null || value === undefined || value === '') return 'n/a';
  
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  
  const { minimumFractionDigits = 0, maximumFractionDigits = 2 } = options;
  
  // Use en-US formatting first, then replace commas with dots
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits,
    maximumFractionDigits
  }).format(num);
  
  // Replace commas (thousands separators) with dots
  return formatted.replace(/,/g, '.');
}

export function formatNumber(value) {
  return customFormatNumber(value, { maximumFractionDigits: 2, minimumFractionDigits: 0 });
}

export function formatDecimal(value, columnName) {
  if (value === null || value === undefined || value === '') return 'n/a';
  const columnObject = getFieldByKey({ columnKey: columnName });
  
  // Convert to string first
  const strValue = String(value);
  const num = parseFloat(strValue);
  
  if (isNaN(num)) return strValue;

  // Defensive check for columnName
  const isPercentage = columnObject?.type === "percent";
  
  // Use custom formatting with dots
  const formatted = customFormatNumber(num, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  
  // Add percentage symbol if needed
  return isPercentage ? `${formatted}%` : formatted;
}

// Helper function to format large numbers with appropriate suffixes
export function formatLargeNumber(value) {
  if (value === null || value === undefined || value === '') return 'n/a';
  
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  
  if (num >= 1000000000) {
    const billions = num / 1000000000;
    return customFormatNumber(billions, { maximumFractionDigits: 1, minimumFractionDigits: 0 }) + 'B';
  } else if (num >= 1000000) {
    const millions = num / 1000000;
    return customFormatNumber(millions, { maximumFractionDigits: 1, minimumFractionDigits: 0 }) + 'M';
  } else if (num >= 1000) {
    const thousands = num / 1000;
    return customFormatNumber(thousands, { maximumFractionDigits: 1, minimumFractionDigits: 0 }) + 'K';
  }
  
  return customFormatNumber(num, { maximumFractionDigits: 0 });
}
